import { ref } from 'vue';
import axios from 'axios';

export function useSpaBreakRooms(apiUrl) {
    const rooms   = ref([]);
    const loading = ref(false);
    const error   = ref(null);

    async function fetchRooms(spaBreakId, locationId, date) {
        loading.value = true;
        error.value   = null;

        try {
            const response = await axios.get(apiUrl, {
                params: { product_id: spaBreakId, location_id: locationId, date },
            });
            rooms.value = response.data.rooms;
        } catch {
            error.value = 'Could not load room options. Please try again.';
            rooms.value = [];
        } finally {
            loading.value = false;
        }
    }

    return { rooms, loading, error, fetchRooms };
}
